import { Text as RNText, StyleProp, TextStyle } from "react-native";

export const Text = ({children, className = "", style}: {children: React.ReactNode, className?: string, style?: StyleProp<TextStyle>}) => {
    return <RNText className={`text-black text-base leading-normal ${className}`} style={style}>{children}</RNText>
}